import { AppKeys } from '../../../core/localization';

export enum TransferDialogs {
    SEND,
    SEND_VALIDATE,
    SEND_CONFIRM,
    REQUEST,
    REQUEST_VALIDATE,
    REQUEST_CONFIRM,
    ACTIVITIES,
    ACTIVITIES_CLOSED,
  }

  export enum TransferType {
    SEND= 1,
    REQUEST = 0
  };
  
  export const TransferTypeNames: { [key: number]: string } = {
    [TransferType.SEND]: AppKeys.Transfer_Type_Send,
    [TransferType.REQUEST]: AppKeys.Transfer_Type_Request,
  };

  
export enum TransferStatus{
    NOT_VALIDATED,
    VALIDATED,
    CONFIRMED,
    PENDING,
    CANCELLED,
    REJECTED,
    COMPLETED,
    DISCARTED,
    //ONLY FOR UI
    CODE_REQUESTED  
  };
  
  export const TransferStatusNames: { [key: number]: string } = {
    [TransferStatus.NOT_VALIDATED]: 'Transfer_Status_NotValidated',
    [TransferStatus.VALIDATED]: 'Transfer_Status_Validated',
    [TransferStatus.CONFIRMED]: 'Transfer_Status_Confirmed',
    [TransferStatus.PENDING]: 'Transfer_Status_Pending',
    [TransferStatus.CANCELLED]: 'Transfer_Status_Cancelled',
    [TransferStatus.REJECTED]: 'Transfer_Status_Rejected',
    [TransferStatus.COMPLETED]: 'Transfer_Status_Completed',
    [TransferStatus.DISCARTED]: 'Transfer_Status_Discarted',
    [TransferStatus.CODE_REQUESTED]: 'CODE_REQUESTED',
  };
  

  export const HistoryPageSize = 10;
  export enum TransferActivityTabs {
    OPEN="OPEN",
    CLOSED="CLOSED",
  }
  
  export const TransferActivitiesTabNames = {
    [TransferActivityTabs.OPEN]: AppKeys.Tx_Act_Tab_Open,
    [TransferActivityTabs.CLOSED]: AppKeys.Tx_Act_Tab_Closed,
  };
  
  export const TransferActivitiesTabDialogMap: { [key: string]: TransferDialogs } = {
    [TransferActivityTabs.OPEN]: TransferDialogs.ACTIVITIES,
    [TransferActivityTabs.CLOSED]: TransferDialogs.ACTIVITIES_CLOSED,
  };